export default "__VITE_ASSET__fce3075f__"